module.exports = __webpack_public_path__ + "img/KinokoTable09.5e82aa85.jpg";